// extracted by mini-css-extract-plugin
export default {"projectLink":"ProjectsPage_projectLink__2WyDV"};